module.exports = __webpack_public_path__ + "static/media/W18-0869_AW_Cod_Burger_LTO_desktop_hero_2396x1473_en.000647ad.jpg";